module.exports = __webpack_public_path__ + "192b61d6338d634ea49cd586711d3d35.png";